import actions from 'od-modules/secure_store/actions';
import {dispatch} from 'od-modules/secure_store/store';
import {updateMembership} from 'od-modules/secure_store/reducers/asyncActionCreators';
import {isPrimeAccount} from 'od-modules/utils/membership_utils';

const PricePublisherMixin = require('od-modules/mixins/price_publisher.mixin');
const isUserSubscribedItem = 'isUserSubscribedItem';

const TYPE = 'MEMBERSHIP_SUBSCRIPTION';

export const MembershipAncillariesModel = Backbone.Model.extend(PricePublisherMixin.extend({
    connect: true,
    selectors: [
        'membershipDiscount',
        'membershipFee',
        'primeMemberSelected',
        'userStatus',
        'primeStatus',
        'isRiskyCreditCard',
        'isExpiringCreditCard',
    ],
    defaults: {
        membershipOffer: {
            price: 0,
            renewalPrice: 0,
        },
        allPrice: 0,
        allPriceFromBackend: 0,
        onePrice: 0,
        onePriceFromBackend: 0,
        quantity: 0,
        membershipInfo: null,
        membershipUpdated: false,
        isPrimeFareSelected: false,
        type: TYPE,
        membershipFee: null,
        primeMemberSelected: {},
        membershipDiscount: {},
        userStatus: null,
        isDisablePrechecked: false,
        isPrimeDecisionTaken: false,
        primeStatus: {},
        lastPaymentMethodCallValue: false,
    },
    getCustomerAccount() {
        const isPrimeUser = isPrimeAccount(this.get('userStatus'));
        const {reactivatePrime} = this.getMembershipSubscriptionDetails();
        return {toBeDisplayed: !reactivatePrime && !isPrimeUser};
    },
    getMembershipOffer() {
        const isPrimeUser = isPrimeAccount(this.get('userStatus'));
        if (!isPrimeUser) {
            const membershipSubscriptionOfferDTO = this.getMembershipSubscriptionOfferDTO();
            const offer = this.buildPriceFromOffer(membershipSubscriptionOfferDTO);
            if (offer) {
                this.set({...offer});
                this.set('membershipOffer', offer);
                this.addOrRemoveItem(true);
            }
        }
    },
    getMembershipSubscriptionOfferDTO() {
        const {membershipSubscriptionOfferDTO} = this.getMembershipSubscriptionDetails();
        return membershipSubscriptionOfferDTO;
    },
    getMembershipSubscriptionDetails() {
        const {membershipSubscriptionDetails} = this.get('primeStatus');
        return membershipSubscriptionDetails;
    },
    buildPriceFromOffer(offer) {
        return {
            ...offer,
            onePriceFromBackend: +offer.price,
            allPriceFromBackend: +offer.price,
        };
    },
    addedSuccessfullyActions(widgetId, hasToApplyDiscount) {
        Odigeo.trigger(`${widgetId}:updateMembershipPricePayment`, hasToApplyDiscount);
    },
    propagateMembershipProduct(widgetId, hasToAddProduct) {
        if (!this.get('isPrimeDecisionTaken') || this.get('lastPaymentMethodCallValue') !== hasToAddProduct) {
            this.set('lastPaymentMethodCallValue', hasToAddProduct);
            this.setMembershipProduct(hasToAddProduct);
            this.updatePbd(widgetId, hasToAddProduct);
            this.addedSuccessfullyActions(widgetId, hasToAddProduct);
        }
    },
    updateMembershipProduct() {
        return dispatch(updateMembership());
    },
    setMembershipProduct(hasToAddProduct) {
        dispatch({type: actions.SET_PRIME_MEMBER_SELECTED, entry: {
            // 0 = the buyer
            travellerId: 0,
            isAddedInPayment: true,
            isSubscriptionAdded: hasToAddProduct,
        }, merge: true});
    },
    updatePbd(widgetId, hasToAddProduct) {
        const isPrimeFareSelected = this.get('isPrimeFareSelected');
        this.set({
            allPrice: hasToAddProduct ? this.get('allPriceFromBackend') : 0,
            onePrice: hasToAddProduct ? this.get('onePriceFromBackend') : 0,
        });
        this.addOrRemoveItem(hasToAddProduct);
        this.toggleSessionInfo(hasToAddProduct);
        this.updatePageStatus(widgetId, isPrimeFareSelected, hasToAddProduct);
    },
    updatePageStatus(widgetId, isPrimeFareSelected, hasToAddProduct) {
        Odigeo.trigger(`${widgetId}:updatePageStatus`, {
            isPriceWithoutDiscountSelected: !isPrimeFareSelected,
            isUserSubscribed: hasToAddProduct,
        });
    },
    toggleSessionInfo(hasToAddProduct) {
        Odigeo.Session.set(isUserSubscribedItem, hasToAddProduct);
        this.set('membershipUpdated', true);
    },
    addOrRemoveItem(hasToAddProduct) {
        hasToAddProduct ?
            this.addItemToPricemanagerCollection(this.attributes) :
            this.removeItemFromPricemanagerCollectionByType(TYPE);
    },
}));
